import {
  amber,
  blue,
  cyan,
  green,
  indigo,
  lightBlue,
  red,
  teal,
  yellow,
} from "@mui/material/colors";
import { useTheme } from "@mui/material/styles";
import { useNavigate } from "react-router-dom";
import AssignmentTurnedInRoundedIcon from "@mui/icons-material/AssignmentTurnedInRounded";
import AssignmentRoundedIcon from "@mui/icons-material/AssignmentRounded";
import ListAltRoundedIcon from "@mui/icons-material/ListAltRounded";
import FactCheckRoundedIcon from "@mui/icons-material/FactCheckRounded";
import ContentPasteOffRoundedIcon from "@mui/icons-material/ContentPasteOffRounded";
import * as DefaultRoutes from "@Routes/DefaultRoutes";
import GenericHomePage from "../../GenericHomePage/GenericHomePage";
import DashboardIcon from "@mui/icons-material/Dashboard";
import FileCopyIcon from "@mui/icons-material/FileCopy";
import StarIcon from "@mui/icons-material/Star";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import ReceiptIcon from "@mui/icons-material/Receipt";

const ClearanceCoordinatorHomePage = () => {
  const navigate = useNavigate();

  const theme = useTheme();
  let sectionsBox = [
    {
      textBeside: "My Pending Orders", // Label displayed next to the icon
      icon: AssignmentRoundedIcon, // MUI Icon component
      iconColor: amber[700], // Icon color
      iconFontSize: theme.spacing(10), // Icon size
      boxbackgroundColor: amber[100], // Box background color
      onClick: () => navigate(DefaultRoutes.pendingOrders), // Action on click
      size: 4,
    },
    {
      textBeside: "All Pending Orders",
      icon: ListAltRoundedIcon,
      iconColor: blue[700],
      iconFontSize: theme.spacing(10),
      boxbackgroundColor: blue[100],
      onClick: () => navigate(DefaultRoutes.allPendingOrders),
      size: 4,
    },
    {
      textBeside: "My Released Orders",
      icon: AssignmentTurnedInRoundedIcon,
      iconColor: green[700],
      iconFontSize: theme.spacing(10),
      boxbackgroundColor: green[50],
      onClick: () => navigate(DefaultRoutes.releasedOrders),
      size: 4,
    },
    {
      textBeside: "All Released Orders",
      icon: FactCheckRoundedIcon,
      iconColor: teal[700],
      iconFontSize: theme.spacing(10),
      boxbackgroundColor: teal[50],
      onClick: () => navigate(DefaultRoutes.allReleasedOrders),
      size: 4,
    },
    {
      textBeside: "Canceled Orders",
      icon: ContentPasteOffRoundedIcon,
      iconColor: red[700],
      iconFontSize: theme.spacing(10),
      boxbackgroundColor: red[50],
      onClick: () => navigate(DefaultRoutes.canceledOrders),
      size: 4,
    },
    {
      textBeside: "Transaction Listing",
      icon: ReceiptIcon,
      iconColor: blue[700],
      iconFontSize: theme.spacing(10),
      boxbackgroundColor: blue[100],
      size: 4,
      onClick: () => navigate(DefaultRoutes.transactionOrderListing),
    },
    {
      textBeside: "Starred Orders",
      icon: StarIcon,
      iconColor: yellow[700],
      iconFontSize: theme.spacing(10),
      boxbackgroundColor: yellow[50],
      size: 4,
      onClick: () => navigate(DefaultRoutes.starredOrders),
    },
    {
      textBeside: "MSDS Directory",
      icon: FileCopyIcon,
      iconColor: cyan[700],
      iconFontSize: theme.spacing(10),
      boxbackgroundColor: cyan[50],
      onClick: () => navigate(DefaultRoutes.msdsdirectory),
      size: 4,
    },
    {
      textBeside: "Payments",
      icon: AccountBalanceIcon,
      iconColor: indigo[700],
      iconFontSize: theme.spacing(10),
      boxbackgroundColor: indigo[50],
      onClick: () => navigate(DefaultRoutes.payments,),
      size: 4,
    },
    {
      textBeside: "Clearance Dashboard",
      icon: DashboardIcon,
      iconColor: lightBlue[700],
      iconFontSize: theme.spacing(10),
      boxbackgroundColor: lightBlue[50],
      size: 12,
      onClick: () => navigate(DefaultRoutes.clearanceDashboard),
    },
  ];
  return <GenericHomePage sectionsBox={sectionsBox} />;
};
export default ClearanceCoordinatorHomePage;
